import { Directive, Input } from '@angular/core';
import { BsDropdownDirective } from 'ngx-bootstrap/dropdown';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { CommonService } from '../services/common.service';

@Directive({
  selector: '[modal-extention]'
})
export class ModalExtention {
  private readonly subscriptionList: Subscription[] = [];

  @Input('modal-extention') modalDir: ModalDirective | BsDropdownDirective;

  constructor (private cs: CommonService) {}

  ngAfterViewInit() {
    const sub1 = this.modalDir?.onShown?.subscribe(() => this.onShow());
    const sub2 = this.modalDir?.onHidden?.subscribe(() => this.onHide());
    this.subscriptionList.push(sub1, sub2);
  }

  onShow() {
    if (this.cs.isBrowser) {
      document?.documentElement?.classList?.add('page-hidden');
    }
  }

  onHide() {
    if (this.cs.isBrowser) {
      document?.documentElement?.classList?.remove('page-hidden');
    }
  }

  ngOnDestroy() {
    this.onHide();
    this.subscriptionList.forEach((sub) => sub.unsubscribe());
  }
}
